<template>
  <v-app>
    <v-container fluid>
      <v-row>
        <v-col cols="12">
          <v-expansion-panels v-model="panel">
            <v-expansion-panel>

              <v-expansion-panel-title
                color="blue-grey-lighten-4"
                class="panel-header"
              >
                Production List
              </v-expansion-panel-title>

              <v-expansion-panel-text>

                <v-card class="pa-4">

                  <v-data-table
                    :headers="headers"
                    :items="getPrdProductionList"
                    :item-value="'id'"
                    class="elevation-1"
                  >

                    <template #item.index="{ index }">
                      {{ ++index }}
                    </template>


                    <template v-slot:item.approval_status_display="{ item }">
                      <v-chip
                        v-if="item.approval_current_process && item.approval_current_process.status === 'Pending'"
                        color="yellow-darken-3"
                        size="small"
                      >
                        Wating for {{ item.approval_current_process.approval_step_name.name }}
                      </v-chip>

                      <v-chip
                        v-else-if="item.approval_current_process && item.approval_current_process.status === 'Approved'"
                        color="green"
                        size="small"
                      >
                        Approved By {{ item.approval_current_process.approval_step_name.name }}
                      </v-chip>
                      <v-chip
                        v-else-if="item.approval_current_process && item.approval_current_process.status === 'Cancelled'"
                        color="red"
                        size="small"
                      >
                        Cancelled By  {{ item.approval_current_process.approval_step_name.name }}
                      </v-chip>
                      <v-chip
                        v-else
                        color="green"
                        size="small"
                      >
                        {{ item.approval_status }}
                      </v-chip>
                    </template>


                    <template #item.production_status="{ item }">

                      <v-chip
                        v-if="item.status == 1"
                        color="success"
                        size="small"
                      >
                        Completed
                      </v-chip>

                      <v-chip
                        v-else
                        color="orange"
                        size="small"
                      >
                        Draft
                      </v-chip>

                    </template>


                    <template v-slot:item.actions="{ item }">

                      <v-icon
                        small
                        @click="viewDetails(item)"
                        class="me-2 edit-button"
                        title="View Production"
                        color="blue"
                      >
                        mdi-file-document-outline
                      </v-icon>

                      <v-icon
                        class="me-2 edit-button"
                        color="primary"
                        v-if="canEdit(item)"
                        @click="editItem(item)"
                      >
                        mdi mdi-pencil-outline
                      </v-icon>

                    </template>

                  </v-data-table>

                </v-card>

              </v-expansion-panel-text>

            </v-expansion-panel>
          </v-expansion-panels>
        </v-col>
      </v-row>
    </v-container>
  </v-app>
</template>



<script setup>

import { ref, computed, onMounted } from "vue"
import { useStore } from "vuex"
import { useRouter } from "vue-router"

const router = useRouter()
const store = useStore()


const panel = ref([0])


/* -----------------------------
TABLE
--------------------------------*/

const headers = [

  { title:"#SL", key:"index"},
  { title:"Code", key:"code"},
  { title:"Production Date", key:"production_date"},
  { title:"Type", key:"type"},
  { title:"Approval Status", key:"approval_status_display"},
  { title:"Production Status", key:"production_status"},
  { title:"Actions", key:"actions"}

]



/* -----------------------------
GETTERS
--------------------------------*/

const getPrdProductionList = computed(()=>{
  return store.getters.getPrdProductionList
})



/* -----------------------------
LOAD DATA
--------------------------------*/

const loadProductionList = async ()=>{

  await store.dispatch("getPrdProductionList")

}



/* -----------------------------
EDIT
--------------------------------*/

function editItem(item){

  router.push({
    name: "create-production",
    query: { id: item.id },
  })

}

function canEdit(item){
    return (!item.approval_status || item.approval_status.toLowerCase() == 'pending' || item.status == 0)
}


/* -----------------------------
VIEW DETAILS
--------------------------------*/

function viewDetails(item){
  router.push({ name: "production-details", params: { id: item.id } });
}



/* -----------------------------
MOUNT
--------------------------------*/

onMounted(()=>{

  loadProductionList()

})

</script>